<script setup lang="ts">
import type { BrokerPerformanceSectionProps } from '.';

import { useAgentProfileStore } from '~/store/agentProfileStore';
import { storeToRefs } from 'pinia';

import { BrokerPerformance } from '~/components/BrokerPerformance';

const props = withDefaults(defineProps<BrokerPerformanceSectionProps>(), {
	isLoading: false
});

const agentProfileStore = useAgentProfileStore();
const { portfolio, highlights } = storeToRefs(agentProfileStore);
const hasContent = computed<boolean>(
	() =>
		(portfolio.value?.regions.length ?? 0) > 0 ||
		(portfolio.value?.propertyTypes.length ?? 0) > 0 ||
		highlights.value.length > 0
);

defineExpose({ hasContent });
</script>

<template>
	<BrokerPerformance
		:class="props.class"
		:is-loading="isLoading"
		:regions="portfolio?.regions"
		:property-types="portfolio?.propertyTypes"
		:numbers="highlights"
	/>
</template>
